<template>
    <div class="application-list">
        <el-header height="35px"><font  size="5" color="#0000FF"><B>应用列表</B></font> </el-header>
        <div class="application-item"
            v-for="(application, index) in applicationList"
            :key="application.id"
            :class="{'selected': application.selected}"
            @click="handleApplicationSelected(index)">
            <div class="application-select-tag"></div>
            <div class="application-content">
                <span class="application-title">{{application.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTask: {}
            };
        },
        props: {
            applicationList: {
                type: Array
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                this.applicationList.forEach((element, i) => {
                    this.$set(this.applicationList[i], 'selected', false);
                });

                this.applicationList.length > 0 && (this.handleApplicationSelected(0));
            },
            async handleApplicationSelected (index) {
                for (let i = 0, len = this.applicationList.length; i < len; i++) {
                    if (this.applicationList[i].selected === true) {
                        this.applicationList[i].selected = false;
                        break;
                    }
                }
                this.applicationList[index].selected = true;
                this.$emit('appSelected', this.applicationList[index]);
            }
        }
    };
</script>

<style lang="less">
    .application-list {
        height: 100%;
        width: 100%;
        border-right: 1px solid #d8dce5;

        display: flex;
        flex-direction: column;

        .application-item {
            height: 40px;
            padding: 3px;
            cursor: pointer;
            // border-top: 1px solid #FFFFFF;
            border-bottom: 1px solid rgb(241, 241, 241);
            flex-shrink:0;
            display: flex;
            // flex-direction: column;
        }
        .application-item.selected {
            .application-select-tag {
                background-color: rgb(46, 150, 185);
            }
            // border-top: 1px solid rgb(241, 241, 241);
            // border-bottom: 1px solid rgb(241, 241, 241);
            background: rgb(255, 255, 255);
        }
        .application-item:hover {
            // border-top: 1px solid rgb(241, 241, 241);
            // border-bottom: 1px solid rgb(241, 241, 241);
            // background: rgb(255, 255, 255);
            background-color: #ecf5ff;
        }
        .application-select-tag {
            width: 5px;
            height: 100%;
            // background-color: rgb(46, 150, 185);
        }

        .application-content {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            color: #0066FF;
            margin: 0 0 0 4px;
            height: 100%;
        }
        .application-title {
            font-size: 18px;
        }
        .application-title2 {
            font-size: 12px;
            color: #00000041
        }

        .define-key {
            font-size: 12px;
            color: #d9e1f3
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/ApplicationList.vue